module.exports = __webpack_public_path__ + "img/4everland.03e72282.png";